<ul class="mx-auto mt-8 list-none p-0">
  <li *ngFor="let item of items; let i = index" class="border border-light-gray">
    <button
      type="button"
      class="w-full flex justify-between items-center text-left p-4 bg-pale-gray"
      [attr.aria-expanded]="isActive(item)"
      [attr.aria-controls]="'panel-' + i"
      [attr.id]="'accordion-' + i"
      (click)="toggle(i)"
    >
      <span class="flex-1">
        <ng-container
          *ngIf="headerTemplate"
          [ngTemplateOutlet]="headerTemplate"
          [ngTemplateOutletContext]="{ $implicit: item, index: i }"
        >
        </ng-container>
      </span>

      <span class="flex items-center">
        <span *ngIf="showClickToExpandHint && !isActive(item)" class="mr-2 text-sm text-gray-600">
          {{ clickToExpandText }}
        </span>

        <i
          [class]="getIconClass(item)"
          aria-hidden="true"
        >
        </i>
      </span>
    </button>

    <div
      class="prism-accordion__body"
      [class.prism-accordion__body--open]="isActive(item)"
      role="region"
      [attr.id]="'panel-' + i"
      [attr.aria-labelledby]="'accordion-' + i"
      [attr.inert]="!isActive(item) ? '' : null"
    >
      <div class="prism-accordion__body-inner">
        <div class="p-4 bg-white" [attr.id]="'panel-content-' + i">
          <ng-container
            *ngIf="bodyTemplate"
            [ngTemplateOutlet]="bodyTemplate"
            [ngTemplateOutletContext]="{ $implicit: item, index: i }"
          >
          </ng-container>
        </div>
      </div>
    </div>
  </li>
</ul>
